import React from "react";
import styled from "styled-components/macro";
import CircularProgress from "@mui/material/CircularProgress";

const Wrap = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  size?: string | number;
  className?: string;
  color?: string;
};

const Loader: React.FC<Props> = ({ size, className, color }) => {
  return (
    <Wrap className={className}>
      <CircularProgress size={size} style={color ? { color } : {}} />
    </Wrap>
  );
};

export default Loader;
